var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 36,
    viewBox: "0 0 27 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_1618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.336426 29.0254L0.554119 28.7206L10.8521 9.1807L10.8738 8.97385L6.33425 0.446986C5.95393 -0.267292 4.88323 -0.086698 4.75841 0.712882L0.336426 29.0254Z",
    fill: "#FFC24A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.464844 28.793L0.629522 28.4719L10.8196 9.13676L6.29137 0.57521C5.91502 -0.131585 4.95935 0.0485917 4.83584 0.839793L0.464844 28.793Z",
    fill: "#FFA712"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_55_1618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.464844 28.793L0.629522 28.4719L10.8196 9.13676L6.29137 0.57521C5.91502 -0.131585 4.95935 0.0485917 4.83584 0.839793L0.464844 28.793Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.183 15.4237L17.563 11.962L14.182 5.50764C13.8611 4.89669 12.9649 4.89493 12.6474 5.50764L10.8411 8.95264V9.24605L14.183 15.4237Z",
    fill: "#F4BD62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1228 15.2794L17.4088 11.914L14.1228 5.65688C13.8107 5.06292 13.0527 5.00069 12.744 5.59636L10.9281 9.09474L10.8738 9.27358L14.1228 15.2794Z",
    fill: "#FFA50E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_55_1618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1228 15.2794L17.4088 11.914L14.1228 5.65688C13.8107 5.06292 13.0527 5.00069 12.744 5.59636L10.9281 9.09474L10.8738 9.27358L14.1228 15.2794Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.336426 29.0254L0.435102 28.9262L0.793627 28.7805L13.9708 15.6523L14.1378 15.1978L10.8506 8.93384L0.336426 29.0254Z",
    fill: "#F6820C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6052 35.6463L26.5309 28.9953L23.1253 8.0215C23.0188 7.36529 22.2137 7.10586 21.744 7.57638L0.336426 29.0255L12.1937 35.6457C12.943 36.0641 13.8557 36.0643 14.6052 35.6463Z",
    fill: "#FDE068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4241 28.9395L23.0444 8.12494C22.9387 7.47371 22.2692 7.20423 21.8031 7.67118L0.46875 28.9847L12.1958 35.5395C12.9394 35.9547 13.8451 35.9549 14.589 35.54L26.4241 28.9395Z",
    fill: "#FCCA3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6052 35.4503C13.8557 35.8683 12.943 35.8681 12.1937 35.4497L0.431929 28.9246L0.336426 29.0254L12.1937 35.6457C12.943 36.0641 13.8557 36.0643 14.6052 35.6463L26.5309 28.9952L26.5017 28.8156L14.6052 35.4503Z",
    fill: "#EEAB37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_55_1618",
    x: 0.464844,
    y: 0.133484,
    width: 10.3547,
    height: 28.6595,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_55_1618"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_55_1618",
    x: 10.8738,
    y: -1.82068,
    width: 7.53491,
    height: 17.1001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_55_1618"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_1618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.2564,
    height: 36,
    fill: "white",
    transform: "translate(0.336426)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.e2c9fe9c800e32ce55272d94062483e8.svg";
export { ForwardRef as ReactComponent };